// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static empresaslista:string="empresaslista";
    public static empresas:string="empresas";
    public static cerrar_session:string="cerrar_session";
    public static mi_perfil:string="mi_perfil";
    public static notificaciones:string="notificaciones";
    public static lostpwd:string="lostpwd";
    public static confirm_new_password:string="confirm_new_password";
    public static configuracion:string="configuracion";
    public static instalacion:string="instalacion";
    public static rol:string="rol";
    public static rollista:string="rollista";
    public static rolformulario:string="rolformulario";
    public static tablas:string="tablas";
    public static tablaslista:string="tablaslista";
    public static tablasformulario:string="tablasformulario";
    public static dispositivos:string="dispositivos";
    public static dispositivoslista:string="dispositivoslista";
    public static recursos:string="recursos";
    public static recursoslista:string="recursoslista";
    public static sensores:string="sensores";
    public static sensoreslista:string="sensoreslista";
    public static dashboards:string="dashboards";
    public static dashboardslista:string="dashboardslista";
    public static dashboardsformulario:string="dashboardsformulario";
    public static recursosformulario:string="recursosformulario";
    public static dispositivosformulario:string="dispositivosformulario";
    public static Dash:string="Dash";
    public static cuadros_de_mando:string="cuadros_de_mando";
    public static Dash_sin_login:string="Dash_sin_login";
    public static test:string="test";
    public static test_informacion:string="test_informacion";
    public static tipos_dash_sin_login:string="tipos_dash_sin_login";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";

}
